var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.permissionIsEnabled("plan:search")
        ? _c("dash-filter", {
            attrs: {
              options: _vm.filterOptions,
              default: _vm.queryString,
              loadingList: _vm.loadingList,
              action: _vm.action,
            },
            on: { error: _vm.setError },
            model: {
              value: _vm.queryString,
              callback: function ($$v) {
                _vm.queryString = $$v
              },
              expression: "queryString",
            },
          })
        : _vm._e(),
      _c("div", { staticClass: "el-section" }, [
        _c(
          "div",
          {
            staticClass:
              "emd-container _highlight_header _header_spaced _footer_spaced_sm",
          },
          [
            _c("div", { staticClass: "emd-container__header" }, [
              _c("h2", { staticClass: "emd-text _size_section" }, [
                _vm._v(_vm._s(_vm.$t("plan.list.title"))),
              ]),
            ]),
            _vm.loadingList
              ? _c(
                  "div",
                  { staticClass: "eu-pa_6 eu-align_center" },
                  [_c("emd-loader", { attrs: { type: "_invert" } })],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "emd-table-responsive" },
                  [
                    _c("Table", {
                      attrs: {
                        fields: _vm.fields,
                        items: _vm.plans.items,
                        toDetail:
                          _vm.permissionIsEnabled("plan:get") && _vm.toDetail,
                      },
                    }),
                    _vm.showEmptyList()
                      ? _c("empty-list", {
                          attrs: {
                            entity: _vm.emptyData.entity,
                            svg: _vm.emptyData.svg,
                          },
                        })
                      : _vm._e(),
                    _vm.showEmptyListFilter()
                      ? _c("empty-list-filter", { attrs: { entity: "plans" } })
                      : _vm._e(),
                  ],
                  1
                ),
            !_vm.loadingList
              ? _c("pagination", {
                  attrs: {
                    pagination: _vm.plans.pagination,
                    totalShowing: _vm.totalItems,
                    type: "list",
                    action: _vm.action,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }